import { FC, useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { useWorkspaceByShortNameQuery } from '~/queries/workspace/useWorkspacesQuery';
import { useParams } from '~/hooks/useParams';
import { PlaceholderType } from './Placeholder';
import { RestrictionGuardType, WorkspaceRestriction } from '../types';
import { passesWorkspaceRestrictions, passesWorkspaceRole } from '../utils';

export const WorkspaceRoleRouteGuard: FC<{ restriction: string; type?: RestrictionGuardType }> = ({
  restriction,
  ...props
}) => {
  const { organizationShortName, workspaceShortName } = useParams<
    'organizationShortName' | 'workspaceShortName'
  >();
  const { data: currentWorkspace } = useWorkspaceByShortNameQuery(
    { organizationShortName, workspaceShortName },
    { enabled: false },
  );

  const pass = passesWorkspaceRole({ restriction, roleId: currentWorkspace?.roleId });
  return pass ? <Outlet /> : <PlaceholderType {...props} />;
};

export const WorkspaceRouteGuard: FC<{
  restrictions: readonly WorkspaceRestriction[];
  type?: RestrictionGuardType;
}> = ({ restrictions, ...props }) => {
  const { organizationShortName, workspaceShortName } = useParams<
    'organizationShortName' | 'workspaceShortName'
  >();
  const { data: currentWorkspace } = useWorkspaceByShortNameQuery(
    { organizationShortName, workspaceShortName },
    { enabled: false },
  );

  const permissions = currentWorkspace?.permissions;
  const pass = useMemo(
    () => passesWorkspaceRestrictions({ restrictions, permissions }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [permissions],
  );

  return pass ? <Outlet /> : <PlaceholderType {...props} />;
};
